import React from 'react';
import { Component, Position, PuzzleTextArea } from "puzzle"
import { TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import { trim } from 'lodash';

type STATE = {
  commentValue: string
}

type PROPS = {
  actionName: 'promote' | 'demote',
  generalReturnFlag: boolean
}

class CommentWarning extends Component<PROPS, STATE> {
  keyUpTimeout: any;
  public state = {
    commentValue: ''
  };

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    const { generalReturnFlag } = this.props;
    if (generalReturnFlag) {
      this.dispatch('commentWarningCompleteButton', Position.end, { buttonDisabled: generalReturnFlag })
    }
  };

  /**
   * CommentValue getter
   */
  getCommentValue = (): string => this.state.commentValue;

  /**
   * TextArea on change handler
   * @param e
   */
  handleChange = (e: TextAreaChangeEvent): void => {
    clearTimeout(this.keyUpTimeout);

    this.setState({
        commentValue: e.value
      },
      () => {
        this.keyUpTimeout = setTimeout(() => {
          this.dispatch('commentWarningCompleteButton', '', {
            buttonDisabled: (trim(this.state.commentValue) !== "")
          })
        }, 300);
      }
    );
  };

  renderBody = () => {
    const {
      actionName,
      generalReturnFlag,
    } = this.props as PROPS;

    return (
      <div>
        <div>
          {this.translate(`${actionName}Text`, { className: 'tp-text-semibold' })}
        </div>
        <br />
        {!generalReturnFlag &&
          <PuzzleTextArea
            asField
            className={'tp-textarea-wrap k-mandatory'}
            label={this.translate('comment')}
            name={'comment'}
            value={this.state.commentValue}
            onChange={this.handleChange}
            rows={2}
          />
        }
      </div>
    )
  }
}

export default CommentWarning;
